const {KitModule, registerModule} = window;

class MarketoForm extends KitModule {
  /**
   * @param {HTMLElement} $element
   */
  constructor($element) {
    super($element);
    this.loadForm();
  }

  /**
   * Call the Marketo loadForm function and define any callback functionality
   */
  loadForm() {
    if (!window.MktoForms2 || !this.$form) {
      // Display fallback content if the Marketo script failed to load (ex. if
      // the user has content blockers enabled in their browser)
      this.$fallback.setAttribute('aria-hidden', false);
      return;
    }

    const formId = this.$form.getAttribute('data-form-id');
    const hostname = this.$form.getAttribute('data-hostname');
    const munchkinId = this.$form.getAttribute('data-munchkin-id');

    window.MktoForms2.loadForm(
      `//${hostname}`,
      munchkinId,
      formId,
      (/* form */) => {
        // Optional callback for performing actions on `form`
        // @see https://developers.marketo.com/javascript-api/forms/api-reference/
      },
    );

    window.MktoForms2.whenReady((form) => {
      const buttonEl = document.querySelector(
        'form[data-form-type="footer"] .mktoButton',
      );
      if (buttonEl) {
        buttonEl.innerHTML = `
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5999 9.40308L30.1963 18.9995M30.1963 18.9995L20.5999 28.5959M30.1963 18.9995H7.80469" id="submitArrowRight" stroke-width="2" stroke-linecap="square"/></svg>
      `;
      }
      const inputEl = document.querySelector(
        'form[data-form-type="footer"] input.mktoEmailField',
      );
      if (inputEl) {
        inputEl.textContent = '';
        inputEl.setAttribute('placeholder', 'Email');
      }
      form.onSuccess((value, thankYouUrl ) => {
        if (formId === form.getId().toString()) {
          this.$form.setAttribute('aria-hidden', true);
          const $thanks = this.$element.querySelector(`.marketoForm__thanks__${form.getId()}`);
          if ($thanks) {
            $thanks.setAttribute('aria-hidden', false);
          }

          const countryField = form.getValues().Country || 'Unknown';
          const businessTypeField = form.getValues().businessType || 'Unknown';

          window.dataLayer.push({
            event: 'connect_with_us',
            formId: formId, // Included formId for tracking
            country: countryField,
            businessType: businessTypeField,
          });

          // Return false to define custom behavior instead of the default defined
          // in Marketo for this form.
          // @see https://developers.marketo.com/javascript-api/forms/api-reference/
          const currentUrl = new URL(window.location.href);
          const thankYou = thankYouUrl ? new URL(thankYouUrl, window.location.origin) : null;

          const isNoRedirect =
            !thankYouUrl ||
            thankYouUrl === '' ||
            (thankYou &&
              currentUrl.origin === thankYou.origin &&
              currentUrl.pathname === thankYou.pathname);

          if (isNoRedirect) {
            return false;
          }
        }
      });
    });
  }
}

registerModule('MarketoForm', MarketoForm);
